export default (value) => {
  if (typeof value === 'string' || value instanceof String) {
    const title = value && value.replace('_', ' ').toLowerCase();
    return title && title.replace(/[a-z]/i, (letter) => letter.toUpperCase()).trim();
  }
  return value;
};
